import React from "react";
import { Breadcrumbs, Container } from "@telia/teddy";
import { Breadcrumb } from "../../../../../../models";
import "./BreadcrumbsWrapper.less";

interface BreadcrumbItemWrapperProps {
    breadcrumb: Breadcrumb;
    isFirst: boolean;
    isLast: boolean;
}

const BreadcrumbItemWrapper: React.FC<BreadcrumbItemWrapperProps> = ({ breadcrumb, isFirst, isLast }) => {
    if (isLast) {
        return (
            <Breadcrumbs.Item>
                <Breadcrumbs.Page>{breadcrumb.name}</Breadcrumbs.Page>
            </Breadcrumbs.Item>
        );
    }

    return (
        <>
            <Breadcrumbs.Item>
                <Breadcrumbs.Link home={isFirst} href={breadcrumb.link} disableVisited>
                    {breadcrumb.name}
                </Breadcrumbs.Link>
            </Breadcrumbs.Item>
            <Breadcrumbs.Separator />
        </>
    );
};

interface BreadcrumbsWrapperProps {
    breadcrumbs?: Breadcrumb[];
}

const BreadcrumbsWrapper: React.FC<BreadcrumbsWrapperProps> = ({ breadcrumbs }) => (
    <Container
        maxWidth={{
            lg: "1312px",
        }}
    >
        <div className="breadcrumbs-wrapper">
            <Breadcrumbs>
                <Breadcrumbs.List>
                    {breadcrumbs?.map((breadcrumb, index) => (
                        <BreadcrumbItemWrapper
                            key={breadcrumb.link}
                            breadcrumb={breadcrumb}
                            isFirst={index === 0}
                            isLast={index === breadcrumbs.length - 1}
                        />
                    ))}
                </Breadcrumbs.List>
            </Breadcrumbs>
        </div>
    </Container>
);

export default BreadcrumbsWrapper;
